export default "__VITE_ASSET__B$8uqA8Y__"